import HttpBase from '@/http/base/HttpBase';
import {AxiosResponse} from 'axios';
import ResponseModel from "@/http/ResponseModel";

/**
 * get请求
 */
export default class Get extends HttpBase {

    async request(url: string, body: any | null = null): Promise<ResponseModel> {
        return new Promise<ResponseModel>((resolve, reject) => {
            this.http.get(url, {
                params: body
            })
                .then((res: AxiosResponse) => {
                    this.defaultThen(res, resolve, reject)
                }).catch((res: any) => {
                this.defaultCatch(res, reject)
            });
        })
    }
}
